import { Component, ChangeDetectionStrategy } from '@angular/core';
import { RouterOutlet } from '@angular/router';

/**
 * Simple page wrapper component that provides consistent background styling
 * and routing shell. Container sizing is handled by global .ap-page-container
 * class applied manually to each page's root element.
 */
@Component({
  selector: 'app-page-wrapper',
  templateUrl: './page-wrapper.component.html',
  imports: [RouterOutlet],
  styleUrls: ['./page-wrapper.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class PageWrapperComponent {}
